/* MOVECREST — Theme-Skripte. Kein Framework, keine externen Abhängigkeiten. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- Mobiles Menü ---- */
    var burger = document.querySelector('[data-mv-burger]');
    var mnav = document.querySelector('[data-mv-mobile-nav]');
    if (burger && mnav) {
      burger.addEventListener('click', function () {
        var open = mnav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* ---- Akkordeons (FAQ + Produktseite) ---- */
    document.querySelectorAll('[data-mv-acc]').forEach(function (item) {
      var btn = item.querySelector('button');
      var panel = item.querySelector('.mv-acc-panel');
      if (!btn || !panel) return;
      if (item.classList.contains('is-open')) {
        /* Bereits offen (z. B. die Beschreibung): Höhe frei lassen,
           damit nachgeladene Bilder den Text nicht abschneiden. */
        btn.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = 'none';
      } else {
        btn.setAttribute('aria-expanded', 'false');
      }
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        var group = item.closest('[data-mv-acc-group]');
        if (group) {
          group.querySelectorAll('[data-mv-acc].is-open').forEach(function (o) {
            o.classList.remove('is-open');
            o.querySelector('.mv-acc-panel').style.maxHeight = null;
            o.querySelector('button').setAttribute('aria-expanded', 'false');
          });
        }
        if (!isOpen) {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ---- Produktgalerie ---- */
    var mainImg = document.querySelector('[data-mv-main-image]');
    document.querySelectorAll('[data-mv-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = t.getAttribute('data-full');
        mainImg.alt = t.getAttribute('data-alt') || '';
        document.querySelectorAll('[data-mv-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    /* ---- Mengen-Stepper ---- */
    document.querySelectorAll('[data-mv-qty]').forEach(function (box) {
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-step'), 10) || 1;
          var next = (parseInt(input.value, 10) || 1) + step;
          input.value = next < 1 ? 1 : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ---- Variantenauswahl: Preis, Verfügbarkeit, URL ---- */
    var pForm = document.querySelector('[data-mv-product-form]');
    if (pForm) {
      var dataEl = document.querySelector('[data-mv-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

      var selects = pForm.querySelectorAll('[data-mv-option]');
      var idField = pForm.querySelector('[name="id"]');
      var atc = pForm.querySelector('[data-mv-atc]');
      var priceEl = document.querySelector('[data-mv-price]');
      var compareEl = document.querySelector('[data-mv-compare]');

      function update() {
        if (!selects.length) return;
        var chosen = [];
        selects.forEach(function (s) { chosen.push(s.value); });
        var match = variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        })[0];

        if (!match) {
          if (atc) { atc.disabled = true; atc.textContent = 'Nicht verfügbar'; }
          return;
        }
        idField.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        if (compareEl) {
          compareEl.textContent = match.compare_at_price || '';
          compareEl.style.display = match.compare_at_price ? '' : 'none';
        }
        if (atc) {
          atc.disabled = !match.available;
          atc.textContent = match.available ? 'In den Warenkorb' : 'Ausverkauft';
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    }

    /* ---- Sortierung in Kollektionen ---- */
    var sort = document.querySelector('[data-mv-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* ---- Warenkorb: Menge ändern / entfernen ---- */
    document.querySelectorAll('[data-mv-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });

    /* ---- Sanftes Scrollen ---- */
    document.querySelectorAll('a[href^="#mv-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return;
        e.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 78, behavior: 'smooth' });
      });
    });

    /* ---- Einblenden beim Scrollen ---- */
    var targets = document.querySelectorAll('.mv-rev');
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (t) { io.observe(t); });
  });
})();
